import script from "./ReportViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportViewer.vue?vue&type=script&setup=true&lang=js"

import "./ReportViewer.vue?vue&type=style&index=0&id=3c9a5ccf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9a5ccf"]])

export default __exports__